export default __webpack_public_path__ + "static/media/checkmark-settings_green.ccc13a07.svg";